export function categoryRoute(path: string) {
  const guide = /^(\/manuals\/[^/?#]+)\/?([?#].*)?$/.exec(path);
  if (guide) { try { return { path: decodeURIComponent(guide[1]), suffix: guide[2] || '' }; } catch { return null; } }
  const match = /^(\/catalog\/([^/?#]+)(?:\/([^/?#]+))?)\/?([?#].*)?$/.exec(path);
  if (!match) return null;
  let key: string;
  try { key = decodeURIComponent(match[1]); } catch { return null; }
  if (/^\/catalog\/(?:brands(?:\/|$)|product-)/.test(key) || key.includes('..')) return null;
  return { path: key, suffix: match[4] || '' };
}
